module.exports = __webpack_public_path__ + "static/media/screen-icon-white.a7601f60.svg";